import { useEffect, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import {
  IdentityA11yAnnouncer,
  IdentityButton,
  IdentityError as IdentityErrorView,
  IdentityFooterInline,
  IdentityHero,
  IdentityLayout,
  IdentityLoading,
  IdentitySuccess,
} from "@speedycore/identity-ui";
import { identityVerifyEmail } from "../lib/identityApi";

export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = useMemo(() => params.get("token") || "", [params]);
  const [status, setStatus] = useState<"idle" | "working" | "ok" | "error">(
    token ? "working" : "idle",
  );
  const [message, setMessage] = useState<string>(
    token ? "Verifying your email…" : "Missing verification token. Open the link from your email.",
  );

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    void identityVerifyEmail(token)
      .then((r) => {
        if (cancelled) return;
        setStatus("ok");
        setMessage(
          r.email
            ? `Verified ${r.email}. You can sign in to SpeedyCore.`
            : "Email verified. You can sign in to SpeedyCore.",
        );
      })
      .catch((err) => {
        if (cancelled) return;
        setStatus("error");
        setMessage(err instanceof Error ? err.message : "Verification link expired — request a new one");
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <>
      <IdentityA11yAnnouncer message={status === "error" ? message : ""} type="error" />
      <IdentityLayout
        hero={
          <IdentityHero
            title="Verify your SpeedyCore account"
            subtitle="Click the link below to activate your identity."
          />
        }
        form={
          <>
            {status === "working" ? (
              <IdentityLoading message="Verifying your email…" />
            ) : status === "ok" ? (
              <IdentitySuccess message="Email verified." />
            ) : status === "error" ? (
              <IdentityErrorView message={message} />
            ) : (
              <IdentityErrorView message={message} />
            )}
            <div className="sc-identity-links" style={{ marginTop: "1rem" }}>
              <Link to="/auth/login">Back to sign in</Link>
            </div>
            <IdentityFooterInline />
          </>
        }
      />
    </>
  );
}
